module.exports = __webpack_public_path__ + "img/RBalearicSlinger64_ua.253f8881.webp";